import { setDownloadOtherOpen } from 'feature/hooks/downloadOtherSlice';
import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { AppDispatch } from 'store/store';

const useDialogDownloadOther = () => {
	const dispatch = useDispatch<AppDispatch>();
	const closeDialogDownloadOther = useCallback(() => {
		dispatch(setDownloadOtherOpen(false));
	}, [dispatch]);

	const handleOpen = useCallback(() => {
		dispatch(setDownloadOtherOpen(true));
	}, [dispatch]);

	return useMemo(
		() => ({
			open: handleOpen,
			close: closeDialogDownloadOther,
		}),
		[handleOpen, closeDialogDownloadOther],
	);
};

export default useDialogDownloadOther;
